import { MessageCircle } from 'lucide-react';
import { trackEvent } from '../lib/analytics';
import { useI18n } from '../i18n';

const WA_BASE = 'https://wa.me/213550357736';

export function StickyWhatsApp() {
  const { locale } = useI18n();
  const label =
    locale === 'fr' ? 'WhatsApp' : locale === 'ar' ? 'واتساب' : 'WhatsApp';
  const text =
    locale === 'fr'
      ? 'Bonjour Codex — je souhaite un devis pour un projet digital (voir aussi codexalgerie.com/fr/devis).'
      : locale === 'ar'
        ? 'مرحبا كودكس — أريد عرض سعر لمشروع رقمي (انظر أيضاً codexalgerie.com/ar/devis).'
        : 'Hello Codex — I would like a quote for a digital project (also see codexalgerie.com/en/devis).';
  const href = `${WA_BASE}?text=${encodeURIComponent(text)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-cursor
      aria-label={label}
      onClick={() => trackEvent('whatsapp_click', { placement: 'sticky' })}
      className="wa-fab fixed z-[80] flex items-center gap-2 px-4 py-3 mono-label"
      style={{ insetInlineEnd: 16, bottom: 16 }}
    >
      <MessageCircle size={18} />
      <span className="hidden sm:inline">{label}</span>
    </a>
  );
}
